import type { API } from 'chessboard/api/config/types';
import type { Game } from 'model/game/types';
import { millisecondsToDeciseconds } from 'src/utils/number/milliseconds-to-deciseconds';
import { getTimestamp } from 'chessboard/model/move/get-timestamp';
import { getPreviousNodeOfSameColor } from 'model/line/get-previous-node-of-same-color';
/**
 * Transform a time value (total game time remaining)
 * to a timestamp value (move time taken)
 */
export function calculateTimestampValue({
  api,
  node,
}: {
  api: API.ExtendedAPI;
  node: Game.Move.Node;
}): number | null {
  const line = api.getLine(0);
  const timeControl = api.timeControl.get();

  if (!line || !timeControl) {
    return null;
  }

  const nodeTime = node.time;
  const lastNode = getPreviousNodeOfSameColor({ api, node });
  const lastNodeTime = lastNode?.time;
  const { baseTime, increment } = timeControl;

  return getTimestamp({
    baseTimeDs: millisecondsToDeciseconds(baseTime),
    incrementDs: millisecondsToDeciseconds(increment),
    lastTimeDs: lastNodeTime,
    currentTimeDs: nodeTime,
  });
}
